import { Controller } from 'stimulus'

// Restrict an <input> to digits only. Applied directly to the field
// (data-controller="numeric-input" + data-action="input->numeric-input#sanitize"),
// so it works for both simple_form inputs (Page 1) and the plain subsidiary inputs
// (Page 3 sub-companies). Strips any non-digit the user types or pastes and
// enforces the field's maxlength, keeping the caret in a sensible position.
//
// The server-side length / numericality validations remain the source of truth;
// this just stops non-numeric characters from ever reaching them.
export default class extends Controller {
  connect() {
    // Clean any pre-filled / resumed value on load.
    this.sanitize()
  }

  sanitize() {
    const el = this.element
    const digits = el.value.replace(/\D/g, '')
    const cleaned = el.maxLength > 0 ? digits.slice(0, el.maxLength) : digits
    if (cleaned === el.value) return

    // Count digits before the caret so we can restore it after rewriting the value
    // (a plain reassignment would otherwise jump the caret to the end).
    const digitsBeforeCaret = el.value
      .slice(0, el.selectionStart || 0)
      .replace(/\D/g, '').length

    el.value = cleaned

    if (typeof el.setSelectionRange === 'function') {
      const caret = Math.min(digitsBeforeCaret, cleaned.length)
      el.setSelectionRange(caret, caret)
    }
  }
}
